// opening the top right menu makes this error to appear in the console. It will fixed in future versions o  the mui but for now it can be fixed by using the experimental muy theme creatro
// TODO: Evaluate if we rather see the error or start using this experimental theme creator
//import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@mui/material/styles';
import { createTheme, adaptV4Theme } from '@mui/material/styles';
// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: 'Nunito Sans',
    h1: {
      //styleName: h1;
      fontSize: '96px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '112px',
      letterSpacing: '-1.5px',
      textAlign: 'left',
    },
    h2: {
      //styleName: h2;
      fontSize: '60px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '72px',
      letterSpacing: '-0.5000000596046448px',
      textAlign: 'left',
    },
    h3: {
      //styleName: h3;
      fontSize: '48px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '56px',
      letterSpacing: '0px',
      textAlign: 'left',
    },
    h4: {
      //styleName: h4;
      fontSize: '34px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '42px',
      letterSpacing: '0.25px',
      textAlign: 'left',
    },
    h5: {
      //styleName: h5;
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'left',
    },
    h6: {
      //styleName: h6;
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '32px',
      letterSpacing: '0.15000000596046448px',
      textAlign: 'left',
    },
    subtitle1: {
      //styleName: subtitle1;
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '28px',
      letterSpacing: '0.15000000596046448px',
      textAlign: 'left',
    },
    subtitle2: {
      //styleName: subtitle2;
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '22px',
      letterSpacing: '0.10000000149011612px',
      textAlign: 'left',
    },
    body1: {
      //styleName: body1;
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.15000000596046448px',
      textAlign: 'left',
    },
    body2: {
      //styleName: body2;
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.15000000596046448px',
      textAlign: 'left',
    },
    button: {
      large: {
        //styleName: button large;
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '26px',
        letterSpacing: '0.46000000834465027px',
        textAlign: 'left',
      },
      medium: {
        //styleName: button large;
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '24px',
        letterSpacing: '0.4px',
        textAlign: 'left',
      },
      small: {
        //styleName: button small;
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 800,
        lineHeight: '22px',
        letterSpacing: '0.46000000834465027px',
        textAlign: 'left',
      },
    },
    caption: {
      //styleName: body2;
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.15000000596046448px',
      textAlign: 'left',
    },
    overline: {
      //styleName: body2;
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.15000000596046448px',
      textAlign: 'left',
    },
  },
  palette: {
    primary: {
      main: '#5954F1',
      dark: '#4842F0',
      light: '#F6F8FE',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00D6D6',
      light: '#CCFFFF',
      contrastText: 'rgba(86,85,85,0.8)',
    },
    text: {
      primary: '#131D29',
      secondary: '#6A7080',
      disabled: 'rgba(19,29,41,0.38)',
    },
    background: {
      default: '#F4F9FD',
    },
    error: {
      main: '#CF3A2F',
      dark: '#990A00',
      light: '#FF7066',
    },
    warning: {
      main: '#FFAB00',
      light: '#FFCD66',
      dark: '#DD8502',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#04C89D',
      light: '#9BFDD4',
      dark: '#13B18E',
    },
  },
  components: {
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          lineHeight: '150%',
          letterSpacing: '0.15px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          //size medium
          borderRadius: '8px',
          boxShadow:
            '0px 1px 5px 0px #0000001F, box-shadow: 0px 2px 2px 0px #00000024, box-shadow: 0px 3px 1px -2px #00000033',
          padding: '8px 22px',
          fontSize: '14px',
          lineHeight: '24px',
          letterSpacing: '0.4px',
          flex: 'none',
          flexGrow: 0,
          margin: '0px 0px',
        },
        sizeLarge: {
          fontSize: '15px',
          lineHeight: '26px',
          letterSpacing: '0.46px',
        },
        sizeMedium: {
          height: '36px',
          lineHeight: '26px',
          letterSpacing: '0.46px',
        },
        text: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          '&$hover': {
            color: 'white',
          },
        },
        outlined: {
          '&$disabled': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          height: '56px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { size: 'small' },
              style: {
                '& .MuiOutlinedInput-root': {
                  height: '38px',
                  borderRadius: '8px',
                },
              },
            },
            {
              props: { size: 'medium' },
              style: {
                '& .MuiOutlinedInput-root': {
                  minHeight: '48px',
                  borderRadius: '12px',
                },
              },
            },
          ],
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '24px',
          letter: '0.17px',
          color: '#131D29',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '52px',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          display: 'flex',
          justifyContent: 'right',
          width: '100%',
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          height: '36px',
          width: '250px',
          left: '318px',
          top: '468px',
          borderRadius: '4px',
        },
        groupedContained: {
          backgroundColor: 'red',
        },
        groupedOutlined: {},
        groupedText: {},
        groupedContainedSecondary: { backgroundColor: 'red' },
        groupedContainedHorizontal: { backgroundColor: 'red' },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow:
            '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12);',
        },
        secondary: {
          color: '#FFFFFF',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.54)',
          '&$disabled': {
            color: 'rgba(0, 0, 0, 0.26)',
          },
        },
        checked: {},
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: '#000000',
        },
      },
    },
    MuiSelect: {},
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '19px',
          letterSpacing: '0.15px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: {
          width: '24px',
          height: '24px',
        },
        sizeMedium: {
          width: '43px',
          height: '43px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          boxShadow:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
        },
        outlined: {
          border: '1px solid rgba(230, 231, 233, 1)',
          borderRadius: '4px',
        },
        rounded: {
          borderRadius: '20px',
        },
        elevation1: {
          boxShadow:
            '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
        },
        elevation2: {
          boxShadow:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
        },
        elevation3: {
          boxShadow:
            '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)',
        },
        elevation4: {
          boxShadow:
            '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
        },
        elevation5: {
          boxShadow:
            '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px rgba(0, 0, 0, 0.14), 0px 1px 14px rgba(0, 0, 0, 0.12)',
        },
        elevation6: {
          boxShadow:
            '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)',
        },
        elevation7: {
          boxShadow:
            '0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12)',
        },
        elevation8: {
          boxShadow:
            '0px 3px 5px -1px rgba(146, 127, 225, 0.2), 0px 5px 8px rgba(146, 127, 225, 0.14), 0px 1px 14px rgba(146, 127, 225, 0.12)',
          borderRadius: '20px',
        },
        elevation9: {
          boxShadow:
            '0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12)',
        },
        elevation10: {
          boxShadow:
            '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
        },
        elevation11: {
          boxShadow:
            '0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12)',
        },
        elevation12: {
          boxShadow:
            '0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12)',
        },
        elevation13: {
          boxShadow:
            '0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12)',
        },
        elevation14: {
          boxShadow:
            '0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12)',
        },
        elevation15: {
          boxShadow:
            '0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)',
        },
        elevation16: {
          boxShadow:
            '0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
        },
        elevation17: {
          boxShadow:
            '0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12)',
        },
        elevation18: {
          boxShadow:
            '0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12)',
        },
        elevation19: {
          boxShadow:
            '0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12)',
        },
        elevation20: {
          boxShadow:
            '0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12)',
        },
        elevation21: {
          boxShadow:
            '0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12)',
        },
        elevation22: {
          boxShadow:
            '0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12)',
        },
        elevation23: {
          boxShadow:
            '0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12)',
        },
        elevation24: {
          boxShadow:
            '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
        },
      },
    },
  },
});

export default theme;
